/* eslint-disable camelcase */

/**
 * @param props
 * @param {ProductVariantCollection} props.variant
 */
const getCompareAtPriceProductVariantUtil = (props) => {
  const variant = props.variant || {}
  const {
    compare_at_price
  } = variant

  const compareAtPriceFloat = parseFloat(compare_at_price)

  if (
    !compareAtPriceFloat ||
    isNaN(compareAtPriceFloat)
  ) {
    return 0
  }

  return compareAtPriceFloat
}

export default getCompareAtPriceProductVariantUtil
